import { Box, MenuItem, SelectChangeEvent, Typography } from '@mui/material';
import {
  Language
} from '@mui/icons-material';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { CustomSelect } from '../../ui/WrappedSelector/styled';
import { cookie } from '@/utils/cookies';
const languages = require('../../../configs/languages');
import useResponsiveUI from '@/hooks/useResponsiveUI';

export interface LangSimpleSwitchProps {
  usedInTheMenuNavigation?: boolean;
  iconSize?: string;
}


const LangSimpleSwitch: React.FC<LangSimpleSwitchProps> = (
  props: LangSimpleSwitchProps,
) => {
  const { usedInTheMenuNavigation, iconSize = '20px' } = props;
  const router = useRouter();
  const { isMobile } = useResponsiveUI();
  const hideArrow = usedInTheMenuNavigation;
  const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    setMounted(true);
  }, []);
  
  const handleLanguageChange = async (event: SelectChangeEvent) => {
    const newLocale = event.target.value as string;
    const { pathname, asPath, query } = router;
    cookie.set('NEXT_LOCALE', newLocale);
    await router.push({ pathname, query }, router.asPath, {
      locale: newLocale,
    });
  };

  // Only apply mobile-specific styles after component has mounted
  const mobileStyles = mounted && isMobile ? {
    width: '100%',
    backgroundColor: (theme) => theme.palette.background.paper
  } : {};

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'row', 
      alignItems: 'center',
      ...mobileStyles
    }}>
      <Language sx={{ fontSize: iconSize }} />
      <CustomSelect
        value={router.locale}
        onChange={handleLanguageChange}
        hidearrow={hideArrow || false}
        sx={(theme) => ({
          fontSize: '14px',
          fontWeight: 500,
          backgroundColor: 'transparent',
          padding: 0,
          border: 'none',
          '&.MuiInputBase-root': {
            width: '100%',
            height: '100%',
            ...(mounted && isMobile && {
              minHeight: '48px'
            })
          },
          '& .MuiSelect-select': {
            padding: `0 0 0 ${theme.spacing(1)}`,
            ...(mounted && isMobile && {
              padding: `0 ${theme.spacing(2)} 0 ${theme.spacing(1)}`,
            })
          },
        })}
      >
        {Object.keys(languages).map((key, index) => {
          return (
            <MenuItem
              value={key}
              key={key}
              sx={(theme) => ({
                padding: mounted && isMobile ? '8px 18px' : '12px 18px',
                fontSize: mounted && isMobile ? '16px' : '14px',
                position: 'relative',
                '&.Mui-selected': {
                  backgroundColor: theme.palette.action.selected,
                  '&:hover': {
                    backgroundColor: theme.palette.action.selected,
                  },
                },
              })}
            >
              {languages[key].name}
            </MenuItem>
          );
        })}
      </CustomSelect>
    </Box>
  );
};

export default LangSimpleSwitch


